// 按照此规范

import axios from 'axios';
import env, { businessWxInfo } from './config';
import { Message } from 'element-ui';
import { safe_base64_encode } from 'ourwill-feutil/common/base64.js';
import createSingleflightFn from 'ourwill-feutil/common/singleflight.js';
// import { cacheGet } from './expriesCache';
import { stringifyQuery } from '@/utils/queryStringFormate.js';
import router from '@/router';
// const ssoUrlLogin = env.ssoUrl + '/login';
const ssoUrlReset = env.ssoUrl + '/resetPassword?service=';
const ssoUrlUser = env.ssoUrl + '/personal';
const ssoUrlInvoice = env.host + '/purchase/invoice';

const reportMessage = (messageBody) => {
	if (typeof window._fedreport_log === 'function') {
		window._fedreport_log(messageBody);
	}
};

const config = {
	...env,
	errors(err) {
		const msg = err.code === 'ECONNABORTED' ? '网络超时，请刷新重试' : err.msg || err.message || err.toString();
		Message.error({
			message: msg,
		});
		console.error(err);
	},
	login(params) {
		const query = {
			service: location.href,
			...params,
		};
		const regex = /\?([^#]*)/; // 匹配问号后面的内容，直到遇到井号
		const regexpResult = regex.exec(location.href);
		const querystr = regexpResult && regexpResult[1];
		const qs = querystr ? '&' + querystr : '';
		if (query.companyId && [1043, 944].includes(+query.companyId)) {
			window.location.href = '/company-login' + '?' + stringifyQuery(query) + qs;
		} else {
			const route = router.resolve({
				name: 'login',
				query,
			});
			window.location.href = route.href;
			// window.location.href = ssoUrlLogin + '?' + stringifyQuery(query) + qs;
		}
		// // const data = res.data;
		// // Message.error({
		// // 	message: data.msg ? data.msg : data.toString(),
		// // });
		// // setTimeout(() => {
		// // 	window.location.href = ssoUrlLogin + encodeURI(env.host + env.apiPath);
		// // }, 500);
		// const host = env.local
		// 	? 'http://127.0.0.1:8010' + '/#/relogin'
		// 	: location.protocol + '//' + location.host + '/admin' + '/#/relogin';
		// window.location.href = host;
	},
	relogin(res) {
		// 跳转登录失效弹窗
		const route = router.resolve({
			name: 'login',
			query: {
				url: location.href,
			},
		});
		location.href = route.href;
	},

	filter(res) {
		const { status, data, config } = res;
		if (localStorage.getItem('REQUEST_DEBUG')) {
			console.log('http request res', res);
		}
		if (status >= 200 && status < 300) {
			if (data.code === 0) {
				res.ok = true;
				return res;
			} else if (data.code == 401) {
				// this.login(res);
				return res;
			}
			if (data.msg && ['服务繁忙', '服务异常'].find((e) => data.msg.includes(e))) {
				// 判断baseURL里面是否为http或https开头，如果有，domain为空，如果没有，则取本地域名
				const domain = config.url.startsWith('http') ? '' : location.origin;
				const url = res.request && res.request.responseURL ? res.request.responseURL : domain + config.url;
				reportMessage({
					error: data.msg,
					url: url,
				});
			}
		} else if (status >= 400) {
			const url = res.request && res.request.responseURL ? res.request.responseURL : location.origin + config.url;
			reportMessage({
				error: JSON.stringify(data),
				status: status,
				url: url,
			});
		}
		this.errors(data.msg);
		res.ok = false;
		return res;
	},
};

function cacheGet(path, ...args) {
	const ttlcache = args.find((arg) => arg?.ttl)?.ttl;
	if (ttlcache) {
		const singleflightFn = createSingleflightFn(this.getFn, {
			ttl: ttlcache,
			keyGenerator: (asyncFnName, ...args) => {
				return path + JSON.stringify(args);
			},
		});
		return singleflightFn(path, ...args);
	}
	return this.getFn(path, ...args);
}

const httpCreate = (baseURL, timeout = 600e3) => {
	const instance = axios.create({
		baseURL: config.apiPath + baseURL,
		timeout,
	});
	instance.interceptors.response.use(config.filter.bind(config), (error) => {
		if (localStorage.getItem('REQUEST_DEBUG')) {
			console.error('response error: ', error);
		}
		// 判断baseURL里面是否为http或https开头，如果有，domain为空，如果没有，则取本地域名
		const domain = error.config.baseURL.startsWith('http') ? '' : location.origin;
		const url =
			error.request && error.request.responseURL
				? error.request.responseURL
				: error.response && error.response.request && error.response.request.responseURL
					? error.response.request.responseURL
					: domain + error.config.baseURL + error.config.url;
		reportMessage({
			error: error.message,
			url: url,
		});
		return { ok: false };
	});
	instance.getFn = instance.get;
	/**
	 * interface cache = {
	 * 	timeout?: number
	 * }
	 * AxiosInstance.get<T = any>(url: string, config?: AxiosRequestConfig, cache?: Boolean | cache): AxiosPromise<T>
	 */
	instance.get = cacheGet.bind(instance);
	return instance;
};

const { errors, filter, baseURL, login } = config;

const invoiceUrl = ssoUrlInvoice + (env.local ? 'http://127.0.0.1:8010' + env.apiPath : config.host + '/admin');
const resetPasswordUrl = ssoUrlReset + encodeURIComponent(config.host);

const getUrlPath = (path, query) => {
	const queryStr = new URLSearchParams(query).toString();
	let url = location.origin + path;
	if (queryStr) {
		url = url + '?' + queryStr;
	}
	return url;
};

const downloadRegionStatist = (id) => {
	return `${config.apiPath}/srv/activity/${id}/regionStatist/download`;
};
//邀请榜导出
const exportInvite = (id) => {
	return `${config.apiPath}/srv/activity/inviteList/export/${id}`;
};
//打赏榜导出
const exportReward = (id) => {
	return `${config.apiPath}/srv/trxorder/rewardList/export/${id}`;
};

const CancelToken = axios.CancelToken;
const isCancel = axios.isCancel;

// 关联企业微信
const businessWxAuth = (userId) => {
	const appid = businessWxInfo.corpID;
	const redirect_uri = encodeURIComponent(businessWxInfo.redirect_uri + '?userId=' + userId);
	// const uri64 = safe_base64_encode('/' + location.hash.replace(/^#\//, '') + location.search);
	const uri64 = safe_base64_encode(location.href);
	// 由于存在企业版，自定义域名下无法使用企业微信授权
	// 方案一： 后端提供一个接口，新打开页面通过浏览器请求这个接口，域名默认为映目的服务商域名，防止企业微信授权验证来源不通过   ---验证中
	// 接口内容
	// const loginURL = `https://open.work.weixin.qq.com/wwopen/sso/3rd_qrConnect?appid=${appid}&redirect_uri=${redirect_uri}&state=${uri64}&usertype=admin`;
	const loginURL = `${config.host}/srv/corp/toAuth?type=0&redirectUrl=${redirect_uri}&state=${uri64}`;
	try {
		// window.open(loginURL);
		location.href = loginURL;
	} catch (e) {
		console.log(e);
	}
};

// 关联企业微信 -- 安装映目直播后跳转
const businessInstall = (userId) => {
	const loginURL = `${config.host}/srv/corp/toAuth/${userId}`;
	try {
		location.href = loginURL;
	} catch (e) {
		console.log(e);
	}
};
export {
	httpCreate,
	CancelToken,
	errors,
	filter,
	baseURL,
	getUrlPath,
	login,
	invoiceUrl,
	resetPasswordUrl,
	isCancel,
	ssoUrlUser,
	downloadRegionStatist,
	exportInvite,
	exportReward,
	businessWxAuth,
	businessInstall,
};
